<template>
  <div id="SafteElectronic" class="safte-electronic-page">
    <panel
      class="no-print"
      :Title="panelTitle"
      :Des="panelDescription"
      :IsBtnBack="true"
      @back="OnPanelBack"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-tab
      class="no-print"
      :Tabs="Tabs"
      :Active="startTab"
      @change="OnTabChange"
    ></net-pa-tab>
    <net-pa-card class="no-print" :Compact="true">
      <template slot="content">
        <div class="tab-content text-right safte-electronic-content py-3 px-3">
          <!-- تب سفته‌ها: لیست، صدور سفته، امضای سفته -->
          <div
            class="tab-pane fade"
            :class="startTab == 'safte-tab-saftes' ? 'show active' : ''"
            id="safte-tab-saftes"
            role="tabpanel"
            aria-labelledby="safte-tab-saftes-tab"
          >
            <template v-if="Level == 0 || Level >= 3">
              <template v-if="Level == 0">
                <div v-if="signCount === 0" class="sf-notice">
                  <i class="fas fa-info-circle"></i>
                  <span>
                    برای ثبت سفته ابتدا باید یک امضای دیجیتال ثبت کنید.
                    <a href="javascript:;" class="font-weight-bold" @click="GoToSigns">ثبت امضا</a>
                  </span>
                </div>
                <safte-list
                  :key="safteListKey"
                  @SignF="OpenLevel6"
                  @NewSafte="OpenLevel3"
                  :Sign="Sign"
                ></safte-list>
              </template>
              <SafteReceive
                v-if="Level == 3"
                @SafteRecieved="DoneSigning"
                @cancel="OPenLevel0"
              ></SafteReceive>
              <sign-Finally
                v-if="Level == 6"
                @SignDone="DoneSigning"
                @cancel="OPenLevel0"
                :SafteToSign="SafteToSign"
              ></sign-Finally>
              <div v-if="Level == 5" class="sf-actions">
                <button type="button" class="sf-btn sf-btn--secondary" @click="OPenLevel0">
                  بازگشت
                </button>
              </div>
            </template>
          </div>

          <!-- تب امضاها: لیست، ثبت مشخصات، ثبت رمز -->
          <div
            class="tab-pane fade"
            :class="startTab == 'safte-tab-signs' ? 'show active' : ''"
            id="safte-tab-signs"
            role="tabpanel"
            aria-labelledby="safte-tab-signs-tab"
          >
            <sign-list
              v-if="Level == 0"
              @loaded="signCount = $event.length"
              @introduceNew="OpenLevel1()"
              @CompeleteSign="OpenLevel2"
              @SafteRecieve="OpenLevel3"
              @ListSafte="OpenLevel5"
            ></sign-list>
            <Introduce-signature
              v-if="Level == 1"
              @introduce_success="succesIntroduce"
              @cancel="OPenLevel0"
            ></Introduce-signature>
            <create-sign
              v-if="Level == 2"
              @create_success="OPenLevel0"
              @cancel="OPenLevel0"
              :IntroduceInfo="IntroduceInfo"
            ></create-sign>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from "../../Tools/NetPa/NetPaCard.vue";
import Panel from "../../Tools/NetPa/Panel.vue";
import CreateSign from "./CreateSign.vue";
import IntroduceSignature from "./IntroduceSignature.vue";
import SafteList from "./SafteList.vue";
import SafteReceive from "./Safte_Receive.vue";
import SignList from "./SignList.vue";
import SignFinally from "./SignFinally.vue";
import NetPaTab from "../../Tools/NetPa/NetPaTab.vue";
import "../../../styles/safte-electronic.css";

export default {
  components: {
    NetPaCard,
    NetPaTab,
    Panel,
    IntroduceSignature,
    CreateSign,
    SignList,
    SafteReceive,
    SafteList,
    SignFinally,
  },
  data() {
    return {
      SafteToSign: null,
      Level: 0,
      IntroduceInfo: {},
      SafteReceiveData: {},
      Sign: {},
      safteListKey: 0,
      // تب شروع هنگام نمایش لیست‌ها؛ فقط با برگشت به لیست‌ها عوض می‌شود
      // (تغییر تب توسط بوت‌استرپ انجام می‌شود، نه Vue)
      startTab: "safte-tab-saftes",
      lastTab: null,
      signCount: null,
      Tabs: [
        { id: "safte-tab-saftes", title: "لیست سفته‌ها" },
        { id: "safte-tab-signs", title: "لیست امضاهای ثبت شده" },
      ],
    };
  },
  computed: {
    panelTitle() {
      if (this.Level === 1 || this.Level === 2) {
        return "ثبت امضا";
      }
      if (this.Level === 3) {
        return "دریافت سفته";
      }
      if (this.Level === 6) {
        return "امضای سفته";
      }
      return "سفته الکترونیک";
    },
    panelDescription() {
      if (this.Level === 1) {
        return "لطفا مشخصات صاحب امضا را با دقت وارد کنید.";
      }
      if (this.Level === 2) {
        return "لطفا یک رمز برای امضای دیجیتال خود وارد کنید.";
      }
      if (this.Level === 3) {
        return "برای صدور سفته اطلاعات لازم را وارد کنید و از صحت اطلاعات اطمینان حاصل فرمایید.";
      }
      if (this.Level === 6) {
        return "سفته انتخاب‌شده را بررسی و امضای نهایی را انجام دهید";
      }
      return "امضاهای دیجیتال و سفته‌های الکترونیکی خود را در این بخش مشاهده و مدیریت کنید.";
    },
  },
  methods: {
    // در لیست‌ها: صفحه‌ی قبلی؛ در مراحل ثبت: برگشت به لیست همان تب
    OnPanelBack() {
      if (this.Level === 0) {
        this.$router.go(-1);
      } else {
        this.Level = 0;
      }
    },
    // با رفتن به تب دیگر، مرحله‌ی در حال انجام لغو می‌شود
    OnTabChange(id) {
      this.lastTab = id;
      if (this.Level !== 0) {
        this.Level = 0;
      }
    },
    GoToSigns() {
      $("#safte-tab-signs-tab").tab("show");
    },
    succesIntroduce(data) {
      this.Level++;
      console.warn(data);
      this.IntroduceInfo = data;
    },
    OPenLevel0() {
      this.Level = 0;
    },
    OpenLevel1() {
      this.Level = 1;
    },
    OpenLevel2(sign) {
      this.IntroduceInfo = {
        national_code: sign.national_code,
        ref_id: sign.request_id,
        fa_first_name: sign.fa_first_name,
        fa_last_name: sign.fa_last_name,
        request_id: sign.request_id,
      };
      this.Level = 2;
    },
    OpenLevel3(sign) {
      this.Level = 3;
      this.SafteReceiveData = sign;
    },
    OpenLevel5(sign) {
      this.Level = 5;
      if (sign) {
        this.Sign = sign;
        console.warn(this.Sign);
      }
    },
    OpenLevel6(sign) {
      this.Level = 6;
      this.SafteToSign = sign;
    },
    DoneSigning() {
      this.Level = 0;
      this.safteListKey++;
    },
  },
};
</script>

<style scoped>
.safte-electronic-page {
  width: 100%;
}

.safte-electronic-content {
  width: 100%;
}
</style>